/** Minimal subset of IOption needed by this library */
export interface IOption {
  id?: any;
  key?: any;
  value: string;
  field?: string;
  inputType?: string;
  type?: string;
  dataType?: string;
  tooltip?: string;
  checked?: boolean;
  selected?: boolean;
  values?: any;
  code?: any;
  associations?: IOption[] | any;
}

/** Minimal subset of IUser fields needed by this library */
export class IUser {
  groups?: IOption[];
  userCountry?: string;
  userCountrySkey?: number;
  userLob?: string;
}

export enum userGroupEnum {
  EDP_WRITE_ACCESS_GROUP_NAME = 'EDP Write Access',
  TRUSTED_USER_GROUP_NAME = 'Trusted User',
  PUBLISH_LISTINGS_GROUP_NAME = 'Publish Listings',
  WINDWARD_REPORTS_GROUP_NAME = 'Windward Reports',
  BULK_EDIT = 'Bulk Edit',
  LEASE_AGREEMENT_REVIEWER = 'Lease Agreement Reviewer',
  LEASE_EXPIRY_NOTIFICATION = 'Lease Expiry Notification',
  QC_TEAM = 'QC Team',
  EDIT_ADDRESSES = 'Edit Addresses ',
  PROPERTY = 'Property',
  LEASE = 'Lease',
  SALE = 'Sale',
  TENANCY = 'Tenancy',
  TIM = 'Tim',
  AVAILABILITY = 'Availability',
  BULK_EDIT_EXCEL = 'Bulk Edit Excel',
  GOVERNANCE_USER = 'Governance User',
  SPACE = 'Space',
  DIGITAL_ASSISTANT_GROUP_NAME = 'Digital Assistant',
  VAS_APPROVER = 'VAS Approver',
}

// Locale is a unique combination of Country and Language
export enum CountryId {
  Australia = 10000013,
  Austria = 10000014,
  Belgium = 10000021,
  China = 10000045,
  'Czech Republic' = 10000060,
  Denmark = 10000061,
  Finland = 10000075,
  France = 10000076,
  Germany = 10000083,
  Hungary = 10000100,
  India = 10000102,
  Italy = 10000109,
  Luxembourg = 10000129,
  Netherlands = 10000155,
  'New Zealand' = 10000158,
  Norway = 10000165,
  Poland = 10000176,
  Portugal = 10000177,
  Romania = 10000181,
  Serbia = 10000196,
  Slovakia = 10000200,
  Spain = 10000207,
  Sweden = 10000213,
  Switzerland = 10000214,
  'United Kingdom' = 10000233,
  'United States of America' = 10000234,
  'Hong Kong, SAR China' = 10000046,
  Ireland = 10000106,
}
